import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration from config file

/**
 * Class representing the view for managing partner providers.
 * @extends JetView
 */
export default class tablePartnersProviderView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        /**
         * Function to handle drag-and-drop list items.
         * @param {Object} data - The data object for the list item.
         * @param {string} id - The ID of the list item.
         * @returns {Object} The modified data object.
         */
        function dragList(data, id) {
            data.value = _(data.value); // Localize the value
            return data; // Return modified data
        }

        // Configuration for the first list of unadded providers
        var list = {
            type: 'space',
            rows: [
                {
                    view: 'template',
                    type: 'header',
                    template: _('Proveedores no agregados'), // Header template for unadded providers
                },
                {
                    view: 'list',
                    id: 'list', // ID for the list of unadded providers
                    drag: true, // Enable drag-and-drop
                    select: true, // Enable selection
                    template: '#value#', // Template for displaying list items
                    externalData: dragList, // Function to handle external data
                },
            ],
        };

        // Configuration for the second list of added providers
        var list2 = {
            type: 'space',
            rows: [
                {
                    view: 'template',
                    type: 'header',
                    template: _('Proveedores Agregados'), // Header template for added providers
                },
                {
                    view: 'list',
                    id: 'list2', // ID for the list of added providers
                    drag: true, // Enable drag-and-drop
                    select: true, // Enable selection
                    template: '#value#', // Template for displaying list items
                    externalData: dragList, // Function to handle external data
                },
            ],
        };

        // Main configuration for the view layout
        return {
            cols: [
                {
                    hidden: !devConfig.getPermAction(
                        'partnerProducts2SubProvidersAdd',
                        'Add', // Check permission for adding sub-providers
                    ),
                    css: 'prm-partnerProducts2SubProvidersAdd', // CSS class for styling
                    rows: [list], // Include the first list
                },
                {
                    hidden: !devConfig.getPermAction(
                        'partnerProducts2SubProvidersAdd',
                        'Add', // Check permission for adding sub-providers
                    ),
                    css: 'prm-partnerProducts2SubProvidersAdd', // CSS class for styling
                    rows: [
                        { gravity: 1 }, // Flexible space
                        { view: 'label', label: _('Todos'), align: 'center' }, // Label for the section
                        {
                            cols: [
                                {
                                    view: 'button', // Button for moving items left
                                    icon: 'wxi-angle-double-left', // Icon for the button
                                    type: 'icon', // Button type
                                    autowidth: true, // Auto width
                                    autoheigth: true, // Auto height
                                    click: () => {
                                        let listArray = $$('list').valueOf().serialize(); // Serialize the unadded providers list
                                        $$('list2')
                                            .valueOf()
                                            .serialize()
                                            .forEach(function (obj) {
                                                listArray.push(obj); // Add items from the added providers list
                                            });
                                        $$('list').parse(listArray); // Update the unadded providers list
                                        $$('list2').clearAll(); // Clear the added providers list
                                        webix
                                            .ui({
                                                view: 'window', // Create a confirmation window
                                                head: {
                                                    view: 'toolbar',
                                                    cols: [
                                                        {
                                                            view: 'label',
                                                            label: _(
                                                                'Desea realizar movimiento?', // Confirmation message
                                                            ),
                                                        },
                                                    ],
                                                },
                                                position: 'center', // Center the window
                                                modal: true, // Make it modal
                                                body: {
                                                    view: 'form',
                                                    id: 'form', // ID for the form
                                                    elements: [
                                                        {
                                                            view: 'text',
                                                            label: _(
                                                                'Observación', // Label for observation field
                                                            ),
                                                            name: 'Note', // Name for the field
                                                            required: true, // Not required
                                                            labelWidth: 100, // Label width
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    view: 'button', // Cancel button
                                                                    value: _(
                                                                        'Cancelar', // Cancel button label
                                                                    ),
                                                                    click: function () {
                                                                        this.getTopParentView().hide(); // Hide the window
                                                                        $$('form').setValues(
                                                                            $$('form').getCleanValues(), // Reset form values
                                                                        );
                                                                        $$('list').clearAll(); // Clear unadded providers list
                                                                        $$('list2').clearAll(); // Clear added providers list
                                                                        webix.ajax().get(
                                                                            devConfig.geturlApi() +
                                                                            'PartnersSubProviders/GetGroupPartnersSubProviders2', // API call to get providers
                                                                            string1,
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var data = JSON.parse(
                                                                                        text, // Parse response data
                                                                                    );
                                                                                    if (!data.HasError) {
                                                                                        let array1 = [];
                                                                                        let array2 = [];
                                                                                        data.Data.IncludedProvidersList.split(
                                                                                            ',',
                                                                                        ).forEach((item) => {
                                                                                            data.Data.ExcludedProvidersList.forEach(
                                                                                                (item2) => {
                                                                                                    if (
                                                                                                        item == item2.id
                                                                                                    ) {
                                                                                                        array1.push(
                                                                                                            item2, // Add matched items to array1
                                                                                                        );
                                                                                                    }
                                                                                                },
                                                                                            );
                                                                                        });
                                                                                        let difference =
                                                                                            data.Data.ExcludedProvidersList.filter(
                                                                                                (x) =>
                                                                                                    !array1.includes(
                                                                                                        x, // Filter out included providers
                                                                                                    ),
                                                                                            );
                                                                                        $$('list').parse(
                                                                                            difference, // Update unadded providers list
                                                                                        );
                                                                                        $$('list2').parse(
                                                                                            array1, // Update added providers list
                                                                                        );
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    },
                                                                },
                                                                {
                                                                    view: 'button', // Save button
                                                                    type: 'form',
                                                                    value: _(
                                                                        'Guardar', // Save button label
                                                                    ),
                                                                    click: function ($e) {
                                                                        var valuesForm = $$('form').getValues(); // Get form values
                                                                        if ($$('form').validate()) {
                                                                            var vthis = this;
                                                                            this.getTopParentView().hide(); // Hide the window
                                                                            let params = {
                                                                                Partner: id_partner, // Partner ID
                                                                                IncludedProvidersList: '',
                                                                                ExcludedProvidersList:
                                                                                    $$('list').data.order.toString(), // Get order of unadded providers
                                                                                Note: valuesForm.Note, // Observation note
                                                                                CountrySelect:
                                                                                    $$('Countries').getValue(), // Selected country
                                                                            };
                                                                            webix
                                                                                .ajax()
                                                                                .headers({
                                                                                    'Content-type': 'application/json', // Set content type
                                                                                })
                                                                                .post(
                                                                                    devConfig.geturlApi() +
                                                                                    'PartnersSubProviders/SaveGroupPartnersSubProviders2', // API call to save providers
                                                                                    params,
                                                                                    {
                                                                                        error: function (
                                                                                            text,
                                                                                            data,
                                                                                            XmlHttpRequest,
                                                                                        ) {
                                                                                            webix.message(
                                                                                                _(
                                                                                                    'Error! ', // Error message
                                                                                                ),
                                                                                            );
                                                                                            vthis
                                                                                                .getTopParentView()
                                                                                                .hide(); // Hide the window
                                                                                        },
                                                                                        success: function (
                                                                                            text,
                                                                                            data,
                                                                                            XmlHttpRequest,
                                                                                        ) {
                                                                                            var data = JSON.parse(
                                                                                                text, // Parse response data
                                                                                            );
                                                                                            if (!data.HasError) {
                                                                                                webix.message(
                                                                                                    _(
                                                                                                        'Sub Proveedor Partner Editado', // Success message
                                                                                                    ),
                                                                                                );
                                                                                            } else {
                                                                                                webix.message(
                                                                                                    _(
                                                                                                        'Error! ', // Error message
                                                                                                    ),
                                                                                                );
                                                                                            }
                                                                                            vthis
                                                                                                .getTopParentView()
                                                                                                .hide(); // Hide the window
                                                                                        },
                                                                                    },
                                                                                );
                                                                        } else {
                                                                            webix.message({
                                                                                title: _(
                                                                                    '¡Error!', // Error title
                                                                                ),
                                                                                type: 'alert-error',
                                                                                text: _(
                                                                                    'Completa los campos...', // Error message
                                                                                ),
                                                                            });
                                                                        }
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                    elementsConfig: {
                                                        on: {
                                                            onChange: function () {
                                                                this.validate(); // Validate form on change
                                                            },
                                                        },
                                                    },
                                                },
                                            })
                                            .show(); // Show the confirmation window
                                    },
                                },
                                {
                                    view: 'button', // Button for moving items right
                                    icon: 'wxi-angle-double-right', // Icon for the button
                                    type: 'icon', // Button type
                                    autowidth: true, // Auto width
                                    autoheigth: true, // Auto height
                                    click: () => {
                                        let list2Array = $$('list2').valueOf().serialize(); // Serialize the added providers list
                                        $$('list')
                                            .valueOf()
                                            .serialize()
                                            .forEach(function (obj) {
                                                list2Array.push(obj); // Add items from the unadded providers list
                                            });
                                        $$('list2').parse(list2Array); // Update the added providers list
                                        $$('list').clearAll(); // Clear the unadded providers list
                                        webix
                                            .ui({
                                                view: 'window', // Create a confirmation window
                                                head: {
                                                    view: 'toolbar',
                                                    cols: [
                                                        {
                                                            view: 'label',
                                                            label: _(
                                                                'Desea realizar movimiento?', // Confirmation message
                                                            ),
                                                        },
                                                    ],
                                                },
                                                position: 'center', // Center the window
                                                modal: true, // Make it modal
                                                body: {
                                                    view: 'form',
                                                    id: 'form', // ID for the form
                                                    elements: [
                                                        {
                                                            view: 'text',
                                                            label: _(
                                                                'Observación', // Label for observation field
                                                            ),
                                                            name: 'Note', // Name for the field
                                                            required: true, // Not required
                                                            labelWidth: 100, // Label width
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    view: 'button', // Cancel button
                                                                    value: _(
                                                                        'Cancelar', // Cancel button label
                                                                    ),
                                                                    click: function () {
                                                                        this.getTopParentView().hide(); // Hide the window
                                                                        $$('form').setValues(
                                                                            $$('form').getCleanValues(), // Reset form values
                                                                        );
                                                                        $$('list').clearAll(); // Clear unadded providers list
                                                                        $$('list2').clearAll(); // Clear added providers list
                                                                        webix.ajax().get(
                                                                            devConfig.geturlApi() +
                                                                            'PartnersSubProviders/GetGroupPartnersSubProviders2', // API call to get providers
                                                                            string1,
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var data = JSON.parse(
                                                                                        text, // Parse response data
                                                                                    );
                                                                                    if (!data.HasError) {
                                                                                        let array1 = [];
                                                                                        let array2 = [];
                                                                                        data.Data.IncludedProvidersList.split(
                                                                                            ',',
                                                                                        ).forEach((item) => {
                                                                                            data.Data.ExcludedProvidersList.forEach(
                                                                                                (item2) => {
                                                                                                    if (
                                                                                                        item == item2.id
                                                                                                    ) {
                                                                                                        array1.push(
                                                                                                            item2, // Add matched items to array1
                                                                                                        );
                                                                                                    }
                                                                                                },
                                                                                            );
                                                                                        });
                                                                                        let difference =
                                                                                            data.Data.ExcludedProvidersList.filter(
                                                                                                (x) =>
                                                                                                    !array1.includes(
                                                                                                        x, // Filter out included providers
                                                                                                    ),
                                                                                            );
                                                                                        $$('list').parse(
                                                                                            difference, // Update unadded providers list
                                                                                        );
                                                                                        $$('list2').parse(
                                                                                            array1, // Update added providers list
                                                                                        );
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    },
                                                                },
                                                                {
                                                                    view: 'button', // Save button
                                                                    type: 'form',
                                                                    value: _(
                                                                        'Guardar', // Save button label
                                                                    ),
                                                                    click: function ($e) {
                                                                        var valuesForm = $$('form').getValues(); // Get form values
                                                                        if ($$('form').validate()) {
                                                                            var vthis = this;
                                                                            this.getTopParentView().hide(); // Hide the window
                                                                            let params = {
                                                                                Partner: id_partner, // Partner ID
                                                                                IncludedProvidersList:
                                                                                    $$('list2').data.order.toString(), // Get order of added providers
                                                                                ExcludedProvidersList: '',
                                                                                Note: valuesForm.Note, // Observation note
                                                                                CountrySelect:
                                                                                    $$('Countries').getValue(), // Selected country
                                                                            };
                                                                            webix
                                                                                .ajax()
                                                                                .headers({
                                                                                    'Content-type': 'application/json', // Set content type
                                                                                })
                                                                                .post(
                                                                                    devConfig.geturlApi() +
                                                                                    'PartnersSubProviders/SaveGroupPartnersSubProviders2', // API call to save providers
                                                                                    params,
                                                                                    {
                                                                                        error: function (
                                                                                            text,
                                                                                            data,
                                                                                            XmlHttpRequest,
                                                                                        ) {
                                                                                            webix.message(
                                                                                                _(
                                                                                                    'Error! ', // Error message
                                                                                                ),
                                                                                            );
                                                                                            vthis
                                                                                                .getTopParentView()
                                                                                                .hide(); // Hide the window
                                                                                        },
                                                                                        success: function (
                                                                                            text,
                                                                                            data,
                                                                                            XmlHttpRequest,
                                                                                        ) {
                                                                                            var data = JSON.parse(
                                                                                                text, // Parse response data
                                                                                            );
                                                                                            if (!data.HasError) {
                                                                                                webix.message(
                                                                                                    _(
                                                                                                        'Sub Proveedor Partner Editado', // Success message
                                                                                                    ),
                                                                                                );
                                                                                            } else {
                                                                                                webix.message(
                                                                                                    _(
                                                                                                        'Error! ', // Error message
                                                                                                    ),
                                                                                                );
                                                                                            }
                                                                                            vthis
                                                                                                .getTopParentView()
                                                                                                .hide(); // Hide the window
                                                                                        },
                                                                                    },
                                                                                );
                                                                        } else {
                                                                            webix.message({
                                                                                title: _(
                                                                                    '¡Error!', // Error title
                                                                                ),
                                                                                type: 'alert-error',
                                                                                text: _(
                                                                                    'Completa los campos...', // Error message
                                                                                ),
                                                                            });
                                                                        }
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                    elementsConfig: {
                                                        on: {
                                                            onChange: function () {
                                                                this.validate(); // Validate form on change
                                                            },
                                                        },
                                                    },
                                                },
                                            })
                                            .show(); // Show the confirmation window
                                    },
                                },
                            ],
                        },
                        { gravity: 2 }, // Flexible space
                    ],
                },
                { rows: [list2] }, // Include the second list
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var string1 = ''; // Initialize string for API parameters

        // Event listener for filtering partner sub-providers
        this.on(this.app, 'partnerSubProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ''; // Reset string for API parameters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to parameters
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to parameters
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other parameters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to parameters
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to parameters
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('list').clearAll(); // Clear unadded providers list
            $$('list2').clearAll(); // Clear added providers list
            webix.ajax().get(
                devConfig.geturlApi() + 'PartnersSubProviders/GetGroupPartnersSubProviders2', // API call to get providers
                string1,
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text); // Parse response data
                        if (!data.HasError) {
                            let array1 = [];
                            let array2 = [];
                            data.Data.IncludedProvidersList.split(',').forEach((item) => {
                                data.Data.ExcludedProvidersList.forEach((item2) => {
                                    if (item == item2.id) {
                                        array1.push(item2); // Add matched items to array1
                                    }
                                });
                            });
                            let difference = data.Data.ExcludedProvidersList.filter(
                                (x) => !array1.includes(x), // Filter out included providers
                            );
                            $$('list').parse(difference); // Update unadded providers list
                            $$('list2').parse(array1); // Update added providers list
                        } else {
                            webix.message('Error! '); // Error message
                        }
                    },
                },
            );
        });

        // Event listener for before dropping items into the added providers list
        $$('list2').attachEvent('onBeforeDrop', function (id, e, node) {
            if (id.from.config.id === 'list') { // Check if the item is being dragged from the unadded providers list
                id.index = $$('list2').data.count(); // Set the drop position to the end of the added providers list
            }
            webix
                .ui({
                    view: 'window', // Create a confirmation window
                    head: {
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make it modal
                    body: {
                        view: 'form',
                        id: 'form', // ID for the form
                        elements: [
                            {
                                view: 'text',
                                label: _('Observación'), // Label for observation field
                                name: 'Note', // Name for the field
                                required: true, // Not required
                                labelWidth: 100, // Label width
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Cancel button label
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('form').setValues(
                                                $$('form').getCleanValues(), // Reset form values
                                            );
                                            $$('list').clearAll(); // Clear unadded providers list
                                            $$('list2').clearAll(); // Clear added providers list
                                            webix.ajax().get(
                                                devConfig.geturlApi() +
                                                'PartnersSubProviders/GetGroupPartnersSubProviders2', // API call to get providers
                                                string1,
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var data = JSON.parse(
                                                            text, // Parse response data
                                                        );
                                                        if (!data.HasError) {
                                                            let array1 = [];
                                                            let array2 = [];
                                                            data.Data.IncludedProvidersList.split(',').forEach(
                                                                (item) => {
                                                                    data.Data.ExcludedProvidersList.forEach((item2) => {
                                                                        if (item == item2.id) {
                                                                            array1.push(
                                                                                item2, // Add matched items to array1
                                                                            );
                                                                        }
                                                                    });
                                                                },
                                                            );
                                                            let difference = data.Data.ExcludedProvidersList.filter(
                                                                (x) =>
                                                                    !array1.includes(
                                                                        x, // Filter out included providers
                                                                    ),
                                                            );
                                                            $$('list').parse(
                                                                difference, // Update unadded providers list
                                                            );
                                                            $$('list2').parse(array1); // Update added providers list
                                                        } else {
                                                            webix.message(
                                                                'Error! ', // Error message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form',
                                        value: _('Guardar'), // Save button label
                                        click: function ($e) {
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                var vthis = this;
                                                this.getTopParentView().hide(); // Hide the window
                                                let params = {
                                                    Partner: id_partner, // Partner ID
                                                    IncludedProvidersList: $$('list2').data.order.toString(), // Get order of added providers
                                                    ExcludedProvidersList: '',
                                                    Note: valuesForm.Note, // Observation note
                                                    CountrySelect: $$('Countries').getValue(), // Selected country
                                                };
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() +
                                                        'PartnersSubProviders/SaveGroupPartnersSubProviders2', // API call to save providers
                                                        params,
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(
                                                                    text, // Parse response data
                                                                );
                                                                if (!data.HasError) {
                                                                    webix.message(
                                                                        _(
                                                                            'Sub Proveedor Partner Editado', // Success message
                                                                        ),
                                                                    );
                                                                } else {
                                                                    webix.message(
                                                                        _(
                                                                            'Error! ', // Error message
                                                                        ),
                                                                    );
                                                                }
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error title
                                                    type: 'alert-error',
                                                    text: _(
                                                        'Completa los campos...', // Error message
                                                    ),
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });

        // Event listener for before dropping items out of the added providers list
        $$('list2').attachEvent('onBeforeDropOut', function (id, e, node) {
            webix
                .ui({
                    view: 'window', // Create a confirmation window
                    head: {
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make it modal
                    body: {
                        view: 'form',
                        id: 'form', // ID for the form
                        elements: [
                            {
                                view: 'text',
                                label: _('Observación'), // Label for observation field
                                name: 'Note', // Name for the field
                                required: true, // Not required
                                labelWidth: 100, // Label width
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Cancel button label
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('form').setValues(
                                                $$('form').getCleanValues(), // Reset form values
                                            );
                                            $$('list').clearAll(); // Clear unadded providers list
                                            $$('list2').clearAll(); // Clear added providers list
                                            webix.ajax().get(
                                                devConfig.geturlApi() +
                                                'PartnersSubProviders/GetGroupPartnersSubProviders2', // API call to get providers
                                                string1,
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var data = JSON.parse(
                                                            text, // Parse response data
                                                        );
                                                        if (!data.HasError) {
                                                            let array1 = [];
                                                            let array2 = [];
                                                            data.Data.IncludedProvidersList.split(',').forEach(
                                                                (item) => {
                                                                    data.Data.ExcludedProvidersList.forEach((item2) => {
                                                                        if (item == item2.id) {
                                                                            array1.push(
                                                                                item2, // Add matched items to array1
                                                                            );
                                                                        }
                                                                    });
                                                                },
                                                            );
                                                            let difference = data.Data.ExcludedProvidersList.filter(
                                                                (x) =>
                                                                    !array1.includes(
                                                                        x, // Filter out included providers
                                                                    ),
                                                            );
                                                            $$('list').parse(
                                                                difference, // Update unadded providers list
                                                            );
                                                            $$('list2').parse(array1); // Update added providers list
                                                        } else {
                                                            webix.message(
                                                                'Error! ', // Error message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form',
                                        value: _('Guardar'), // Save button label
                                        click: function ($e) {
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                var vthis = this;
                                                this.getTopParentView().hide(); // Hide the window
                                                let params = {
                                                    Partner: id_partner, // Partner ID
                                                    IncludedProvidersList: '', // Empty for excluded
                                                    ExcludedProvidersList: $$('list').data.order.toString(), // Get order of unadded providers
                                                    Note: valuesForm.Note, // Observation note
                                                    CountrySelect: $$('Countries').getValue(), // Selected country
                                                };
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() +
                                                        'PartnersSubProviders/SaveGroupPartnersSubProviders2', // API call to save providers
                                                        params,
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(
                                                                    text, // Parse response data
                                                                );
                                                                if (!data.HasError) {
                                                                    webix.message(
                                                                        _(
                                                                            'Sub Proveedor Partner Editado', // Success message
                                                                        ),
                                                                    );
                                                                } else {
                                                                    webix.message(
                                                                        _(
                                                                            'Error! ', // Error message
                                                                        ),
                                                                    );
                                                                }
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error title
                                                    type: 'alert-error',
                                                    text: _(
                                                        'Completa los campos...', // Error message
                                                    ),
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
